import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useRolesForSelect = () => {
  const { t } = useTranslation();
  return useMemo(
    () => [
      { label: t("label-admin"), value: 900 },
      { label: t("label-read"), value: 100 },
      { label: t("label-write"), value: 200 },
      { label: t("label-report-reader"), value: 300 },
      { label: t("label-report-creator"), value: 400 },
    ],
    []
  );
};
